const modules = [
    'CA_SP'
]
export default modules